const moment = require('moment');

export const defaultSelectedListaChequeo = () => {
    return {
        id: null,
        id_tipo_lista_chequeo: null,
        id_empresa: null,
        id_ubicacion: null,
        seleccionar_ubicacion: true,
        unidad_negocio: null,
        fecha_inicio_visita: moment().format('YYYY-MM-DD hh:mm:ss'),
        fecha_cierre_visita: null,
        correo_responsable: null,
        ubicacion: null,
        proximo_seguimiento: null,
        observacion_general: null,
        planeacion: null,
        hallazgos: [],
        wor_worker_id: null
    };
};

export const filtro = () => {
    return {
        id_empresa: '',
        id_tipo_lista_chequeo: null,
        paginado: true,
        unidad_negocio: '',
        seleccionar_ubicacion: true,
        id_ubicacion: null,
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'DESC',
        range_date: null,
        wor_worker_id: null,
    };
};

export default {
    selectedListaChequeo: defaultSelectedListaChequeo(),
    ubicaciones: [],
    ubicaciones_filtro: [],
    imagen_seleccionada: null,
    accion: 'Crear',
    listaChequeo: [],
    listasChequeoExistente: {data:[]},
    tipo_lista_chequeo: {},
    tipoListaChequeo: [],
    tipoSeguimientos: [],
    listaTipoSeguimientos: [],
    empresas: [],
    empresas_filtro: [],
    filtro: filtro(),
    hallazgoArr: [],
    graficaGeneral: [],
    graficaTipoSeg: [],
    datoGrafica1: [],
    datoGrafica2: [],
    cargando_datos_select: false,
    plan_accion: {
        data: {
            hallazgos: []
        }
    },
    datos_accion: {
        id: '',
        responsable: '',
        fecha_cierre_visita: '',
        fecha_inicio_visita: ''
    },
    imagenPlanAccion: [],
    planeacionesAuditoriasHallazgos: [],
    arrImage: [],
    imagenSelecc: {},
    imagenChange: {},
    dataToChartGeneralFindings: [],
    dataToChartPercentageOfComplianceByItem: []
};
